module.exports = __webpack_public_path__ + "static/media/i_8.aaf3fc9d.png";